import React, { Fragment } from "react";
import { Formik, Form, FormikErrors } from "formik";
import { TextField } from "../../../components/src/form";
import { Button } from "../../../components/src/Button";
import { passwordLogin, setCookieOnServices } from "../utils/authUtils";
import { REACT_APP_DB_NAME, REACT_APP_NAME } from "../env";

interface PasswordLoginProps {
    onSubmit: (loginData: any) => void;
    onToggleMode: () => void;
}

export const PasswordLogin: React.FC<PasswordLoginProps> = ({ onSubmit, onToggleMode }) => {
    const handleSubmit = async (submitValues: { personalNumber: string; password: string }, { setSubmitting, setErrors }: any) => {
        setSubmitting(true);

        try {
            const result = await passwordLogin(submitValues.personalNumber, submitValues.password);
            localStorage.setItem("orderRef", "");
            await setCookieOnServices(result.data.access_token);

            const expireDate = new Date();
            expireDate.setSeconds(expireDate.getSeconds() + Number(result.data.expires_in));
            const expires = expireDate.toISOString();

            onSubmit({
                expires: expires,
                loggedIn: true,
                token: result.data.access_token,
                username: result.data.user_display_name,
                userId: result.data.user_id ? result.data.user_id : "",
                statusMessage: "",
                errorMessage: "",
                acceptedTerms: result.data.accepted_terms
            });
        } catch (error: any) {
            const formErrors: FormikErrors<Record<string, string>> = {};

            if (error?.response?.data?.error === "Unauthorized: incorrect password") {
                formErrors["password"] = "Unauthorized: incorrect password";
            } else if (error?.response?.data?.error === "User not found") {
                formErrors["personalNumber"] = "User not found";
            } else if (error?.response?.data?.error) {
                formErrors["personalNumber"] = error?.response?.data?.error;
            } else if (error?.response?.status === 429) {
                formErrors["personalNumber"] = error.response.data;
            } else {
                console.error(error);
                formErrors["personalNumber"] = "error " + error.toString();
            }
            setErrors(formErrors);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="fixed inset-0 flex justify-center items-center bg-cover bg-center bg-no-repeat px-4"
            style={{
                backgroundImage: "url(/background_europe.jpg)",
                fontFamily: "Inter"
            }}
        >
            <div className="flex flex-wrap -mx-2 w-full max-w-[380px]">
                <div className="w-full" style={{ background: "white", borderRadius: "5px" }}>
                    <h2
                        className="text-center py-2"
                        style={{
                            justifyContent: "center",
                            alignItems: "center",
                            borderTopLeftRadius: "5px",
                            borderTopRightRadius: "5px",
                            background: "#0284c7",
                            color: "white"
                        }}
                    >
                        {REACT_APP_NAME.toUpperCase()}
                    </h2>
                    <h2 className="ml-2 mr-2 text-center" style={{ justifyContent: "center", alignItems: "center" }}>
                        <span>Login with password</span>
                    </h2>
                    <div className="flex flex-wrap -mx-2 px-4">
                        <div className="flex-1 px-2">
                            <Formik initialValues={{ personalNumber: "", password: "" }} onSubmit={handleSubmit}>
                                {({ isSubmitting }) => (
                                    <Fragment>
                                        <Form autoComplete="off">
                                            <div>
                                                <div className="flex flex-wrap -mx-2">
                                                    <div className="mb-4 w-full px-2">
                                                        <TextField
                                                            name="personalNumber"
                                                            label="Personnummer"
                                                            className="center"
                                                            disabled={isSubmitting}
                                                            autoComplete="username"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="flex flex-wrap -mx-2">
                                                    <div className="mb-4 w-full px-2">
                                                        <TextField
                                                            name="password"
                                                            label="password"
                                                            type="password"
                                                            className="center"
                                                            disabled={isSubmitting}
                                                            autoComplete={"current-password"}
                                                        />
                                                    </div>
                                                </div>

                                                <Button
                                                    className="w-full"
                                                    variant="secondary"
                                                    id="loginsubmitbutton"
                                                    disabled={isSubmitting}
                                                    type="submit"
                                                >
                                                    Login
                                                </Button>
                                            </div>
                                        </Form>
                                    </Fragment>
                                )}
                            </Formik>
                        </div>
                    </div>

                    <div className="mt-4 mb-4 text-center" style={{ justifyContent: "center", alignItems: "center" }}>
                        {REACT_APP_DB_NAME === "prod" ? (
                            <button
                                className="text-sky-600 hover:text-sky-800 underline bg-transparent border-none cursor-pointer"
                                type="button"
                                onClick={onToggleMode}
                            >
                                Login with BankID app instead
                            </button>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};
